import { LeaderBoard } from "./LeaderBoard"

export enum SeasonIdTemp{
    LIVE = "live",
    LAST_LIVE = "lastLive"
}

export interface Season{
    readonly season_id: number | SeasonIdTemp
    readonly season_name: string
    readonly valid_from?: string
    readonly valid_to?: string
    readonly leaderboards?: LeaderBoard[]
}